import httpClient from "./httpClient";

export default {
  // Staff
  async getStaff() {
    const response = await httpClient.get(`/staff`);
    return response.data;
  },

  async deleteStaff(staffId) {
    const response = await httpClient.delete(`/staff/${staffId}`);
    return response.data;
  },

  async createStaff(staff) {
    const response = await httpClient.post(`/staff`, {
      ...staff
    });
    return response.data;
  },

  async updateStaff(staff) {
    const response = await httpClient.put(`/staff/${staff.id}`, {
      ...staff
    });
    return response.data;
  }
};
